import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import RadioButton from "../../../../shared/components/RadioButton/RadioButton";
import { h6Medium, h6Regular, h7Regular } from "../../../../shared/typography";
import { pointer } from "../../../../shared/mixins";

const INSTALLMENT_OPTIONS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

interface InstallmentsSelectorProps {
  wantsInstallments: boolean;
  setWantsInstallments: (value: boolean) => void;
  installmentsCount: number | null;
  setInstallmentsCount: (value: number) => void;
}

const useStyles = makeStyles({
  question: {
    ...h6Regular,
    marginBottom: 16,
  },
  choices: {
    display: "flex",
    alignItems: "center",
    gap: 32,
    marginBottom: 24,
  },
  choiceLabel: {
    ...h6Regular,
  },
  countLabel: {
    ...h6Medium,
    marginBottom: 4,
  },
  countSubLabel: {
    ...h7Regular,
    opacity: 0.64,
    marginBottom: 16,
  },
  countOptions: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 24,
  },
  countOption: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    border: "1px solid rgba(21, 34, 47, 0.18)",
    background: "#FFF",
    color: "#15222F",
    ...h6Medium,
    ...pointer,
  },
  countOptionSelected: {
    border: "none",
    background: "#80BB34",
    color: "#FFF",
  },
});

const InstallmentsSelector: React.FC<InstallmentsSelectorProps> = ({
  wantsInstallments,
  setWantsInstallments,
  installmentsCount,
  setInstallmentsCount,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <div className={classes.question}>
        {t("checkout.splitIntoMonthlyPayments")}
      </div>

      <div className={classes.choices}>
        <RadioButton
          name="wants-installments"
          value="yes"
          checked={wantsInstallments}
          onChange={() => setWantsInstallments(true)}
          color="#80BB34"
        >
          <span className={classes.choiceLabel}>{t("common.Yes")}</span>
        </RadioButton>
        <RadioButton
          name="wants-installments"
          value="no"
          checked={!wantsInstallments}
          onChange={() => setWantsInstallments(false)}
          color="#80BB34"
        >
          <span className={classes.choiceLabel}>{t("common.No")}</span>
        </RadioButton>
      </div>

      {wantsInstallments ? (
        <>
          <div className={classes.countLabel}>
            {t("checkout.forHowManyPayments")}
          </div>
          <div className={classes.countSubLabel}>
            {t("checkout.paymentsFirstDay")}
          </div>
          <div className={classes.countOptions}>
            {INSTALLMENT_OPTIONS.map((count) => (
              <button
                type="button"
                key={count}
                className={`${classes.countOption} ${
                  installmentsCount === count ? classes.countOptionSelected : ""
                }`}
                onClick={() => setInstallmentsCount(count)}
              >
                {count}
              </button>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default InstallmentsSelector;
